import React, { useEffect } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import {
  toggleHamburgerMenu,
  setNavbarTab,
  setContactNotification,
} from '../../Actions/ToggleActions';
import { TAB_TYPES, FETCH_STATUS, CAREER_STATUS } from '../../Constants';
import { getLocalAreaData } from '../../Utils/localStorageUtil';

const Navbar = () => {
  const dispatch = useDispatch();

  const { text: { navbar: pageText } } = useSelector(state => state.Language);
  const { status } = useSelector(state => state.Career);
  const { careerStatus } = useSelector(state => state.MunicipalityReducer);
  const { hamburgerMenu, showContactNotification } = useSelector(state => state.ToggleReducer);
  const { navbar: { activeTab, isOpen } } = useSelector(state => state.ToggleReducer);

  useEffect(() => {
    setTimeout(() => {
      dispatch(setContactNotification(true));
    }, 30000);
  }, []);

  const renderNavbarButton = (id, icon, tabType, text) =>
    (
      <div className="row">
        <div className={classNames('contact-circle', { hide: (id !== 'contact-button' || !showContactNotification) })}>
          <p>!</p>
        </div>
        <label
          className={
            classNames(
              'border-top',
              { selected: activeTab === { tabType } },
              )}
          htmlFor={id}
        >
          <input
            type="button"
            id={id}
            className={classNames(icon, { 'has-favourites': id === 'favourites-button' && getLocalAreaData().length !== 0 })}
            onClick={() => { dispatch(setNavbarTab(tabType)); }}
          />
          {text}
        </label>
      </div>
    );


  return (
    <ReactCSSTransitionGroup
      transitionName="nav-bar"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={300}
    >
      {isOpen ?
        <div className={hamburgerMenu ? 'navigation-bar-wrapper hamburger' : 'navigation-bar-wrapper'} >
          <div className="row show-for-small-only sticky-top">
            <div className={classNames('contact-circle', { hide: !showContactNotification })}>
              <p>!</p>
            </div>
            <input type="button" className={hamburgerMenu ? 'hamburger-button' : 'close-button'} onClick={() => dispatch(toggleHamburgerMenu(!hamburgerMenu))} />
          </div>
          <div className="inner-wrapper">
            { renderNavbarButton('filter-button', 'icon-filter', TAB_TYPES.FILTER, pageText.filter) }
            { renderNavbarButton('favourites-button', 'icon-favourites', TAB_TYPES.FAVORITES, pageText.favorites) }
            { renderNavbarButton('contact-button', 'icon-contact', TAB_TYPES.CONTACT, pageText.contact) }
            { status === FETCH_STATUS.SUCCEEDED && careerStatus === CAREER_STATUS.LIVE ?
              renderNavbarButton('career-button', 'icon-school', TAB_TYPES.TEACHER, pageText.career) : null
            }
          </div>
        </div>
      : null}
    </ReactCSSTransitionGroup>
  );
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/Components/Navbar/Navbar.js